import { createContext } from "react";

export type ToastKind = "ok" | "error" | "info";

export interface ToastApi {
  push: (kind: ToastKind, text: string, durationMs?: number) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);
